import { useSelector } from "react-redux";
import { CheckCircleIcon } from "staysure-component-library";

import { RootState } from "@/store/root-reducer";

import { useContactDetailsContext } from "../../../provider/contact-details.provider";
import { descriptionSectionCmsData } from "../../../utils/contact-details-page.util";

type ContactDetailsDescriptionTitleProps = {
  isShowIcon: boolean;
};

function ContactDetailsDescriptionTitle({
  isShowIcon,
}: Readonly<ContactDetailsDescriptionTitleProps>) {
  const { isFilled } = useSelector((state: RootState) => state.contactDetails);
  const { cmsData } = useContactDetailsContext();

  const { filledStateTitle, title } = descriptionSectionCmsData(cmsData);

  return (
    <>
      {isShowIcon && isFilled && (
        <div id="tick-icon" className="mb-spacing-m flex justify-center">
          <CheckCircleIcon fill="transparent" size="XL" />
        </div>
      )}
      <div className=" mb-spacing-xs md:mb-spacing-m  ">
        <h1 className="font-header-font md:text-[31px] text-[20px] text-center md:leading-[34.1px] leading-[21px] text-dark-text-title">
          {isFilled ? filledStateTitle : title}
        </h1>
      </div>
    </>
  );
}
export default ContactDetailsDescriptionTitle;
